import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { producersApi } from '../../lib/api';
import { DataTable } from '../../components/ui/DataTable';
import { useAuth } from '../../hooks/useAuth';
const columns = [
    {
        key: 'name',
        header: 'Producer',
        render: (row) => _jsx("span", { className: "font-medium text-gray-900", children: row.name }),
    },
    {
        key: 'region',
        header: 'Region',
        render: (row) => row.regionName ?? '—',
        className: 'text-gray-600',
    },
    {
        key: 'country',
        header: 'Country',
        render: (row) => row.countryCode ?? '—',
        className: 'w-20 text-gray-500',
    },
];
export function ProducersPage() {
    const navigate = useNavigate();
    const { activeAccount } = useAuth();
    const [search, setSearch] = useState('');
    const { data, isLoading } = useQuery({
        queryKey: ['producers', activeAccount?.id, search],
        queryFn: () => producersApi.list(search || undefined),
        enabled: Boolean(activeAccount),
    });
    return (_jsxs("div", { className: "space-y-4", children: [_jsxs("div", { children: [_jsx("h1", { className: "page-title", children: "Producers" }), _jsxs("p", { className: "text-sm text-gray-500 mt-0.5", children: [data?.producers?.length ?? 0, " producers"] })] }), _jsxs("div", { className: "relative max-w-sm", children: [_jsx(Search, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" }), _jsx("input", { type: "search", placeholder: "Search producers\u2026", value: search, onChange: (e) => setSearch(e.target.value), className: "input pl-9" })] }), _jsx("div", { className: "card overflow-hidden", children: _jsx(DataTable, { columns: columns, data: data?.producers ?? [], isLoading: isLoading, rowKey: (row) => row.id, onRowClick: (row) => navigate(`/wines?producerId=${row.id}`), emptyTitle: "No producers", emptyDescription: search ? 'Try adjusting your search' : 'Producers are added when you create wines' }) })] }));
}
